import { useParams, Navigate } from 'react-router-dom';
import { parseToken, isTokenExpired, type UploadToken } from '../lib/uploadTypes';
import UploadPortal from '../components/UploadPortal/UploadPortal';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './Upload.css';

export default function Upload() {
  const { token: tokenString } = useParams<{ token: string }>();

  if (!tokenString) {
    return <Navigate to="/" replace />;
  }

  // Parse and validate token
  const token: UploadToken | null = parseToken(tokenString);

  if (!token) {
    return (
      <>
        <Header />
        <div className="upload-error">
          <h1>Invalid Upload Link</h1>
          <p>The upload link you provided is invalid or malformed.</p>
          <p>Please contact support if you believe this is an error.</p>
        </div>
        <Footer />
      </>
    );
  }

  if (isTokenExpired(token)) {
    return (
      <>
        <Header />
        <div className="upload-error">
          <h1>Upload Link Expired</h1>
          <p>
            This upload link expired on {new Date(token.expiresAt * 1000).toLocaleDateString()}.
          </p>
          <p>Please request a new upload link.</p>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="upload-page">
        <UploadPortal token={token} tokenString={tokenString} />
      </div>
      <Footer />
    </>
  );
}
